/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { PostAccountWebpushMutationRequest, PostAccountWebpushMutationResponse } from '../types/PostAccountWebpush.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getPostAccountWebpushUrl() {
  const res = { method: 'POST', url: `/account/webpush` as const };
  return res;
}

/**
 * @description Update account webpush association
 * @summary Update account webpush association
 * {@link /account/webpush}
 */
export async function postAccountWebpush(
  data: PostAccountWebpushMutationRequest,
  config: Partial<RequestConfig<PostAccountWebpushMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<PostAccountWebpushMutationResponse, ResponseErrorConfig<Error>, PostAccountWebpushMutationRequest>({
    method: 'POST',
    url: getPostAccountWebpushUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
